<template>
  <div class="box"> 
    <div class="newsviews">
      <!-- <div class="tab">
        <router-link to="/">首页</router-link>>{{title}}<span v-if="childName">>{{ childName }}</span>
      </div> -->
      <div class="views">
        <div class="leftitem">
          <ul v-if="CategoryChildren&&CategoryChildren.length>0">
            <li v-for="(child,index) in CategoryChildren" :key="index"  :class="(child.uuid==childId)?'activeli':''" @click="changeArticleList(child.uuid,child.name)">
              <i :class="`leftIcon iconfont ${AllIcons[child.name]}`"></i>
               <p> {{ child.name }}</p>
            </li>
          </ul>
          <ul v-else>
            <li  class="activeli" >
              <i :class="`leftIcon iconfont ${AllIcons[title]}`"></i>
               <p> {{title }}</p>
            </li>
          </ul>
        </div>
        <div class="rightitem">
          <div v-if="arrPicNews.length>0">
            <el-carousel height="393px" direction="vertical" :autoplay="true" class="swiper">
              <el-carousel-item v-for="( picNew , index) in arrPicNews" :key="index" >
                <div class="swiperLeft" @click="$router.push(`/news/info/${picNew.plateid}/${picNew.uuid}`)">
                  <img :src="`${IP_TEST}/uploads/${picNew.picsrc}`" :alt="picNew.title" width="756" height="392">
                </div>
                <div class="swiperRight">
                  <h2 @click="$router.push(`/news/info/${picNew.plateid}/${picNew.uuid}`)">{{ picNew.title }}</h2>
                  <p>{{ picNew.description}}</p>
                  <p class="pageIndex">{{ index+1 }} / {{ arrPicNews.length }}</p>
                </div>
              </el-carousel-item>
            </el-carousel>
          </div>
          <div class="title">
            <h1>{{ childName?childName: title}}</h1>
          </div>
          <ul>
            <router-link tag="li" v-for="(item,index) in realList" :key="index" :to="`/news/info/${item.plateid}/${item.uuid}`">
                  <h4><i class="iconfont icon-component-full2" style="    margin-right: 11px;"></i>{{item.title}}</h4>
                  <span class="addtime">{{item.addtime|filterdate}}</span>
            </router-link>
          </ul>
          <el-pagination
          background
            @current-change="toPage"
            :current-page="current"
            :page-size="10"
            layout="total, prev, pager, next, jumper"
            :total="totalNum">
          </el-pagination>
        </div>
        
      </div>
    </div>
  </div>
</template>

<script>
import { IP_TEST,AllIcons } from '@/config'
import { getNewsViews, getSearch } from '@/request/get'
import { getPicNews,getPlatePicNews } from '../request/get';
export default {
  name: "NewsViews",
  components: {
  },
  data() {
    return {
      plateId: this.$route.params.plateId||'',
      childId: this.$route.params.childId||'',
      CategoryChildren:[],
      childName:"",
      current: 1,
      totalNum:0,
      list: [],
      realList: [],
      curChildId:"",
      arrPicNews:[],
      AllIcons,
      IP_TEST: IP_TEST
    }
  },
  filters: {
    filterdate(date) {
      return date.slice(0, 10);
    },
    filterPage(page) {
      if (page === 0) {
        return ""
      }
      return page
    }
  },
  computed: {
    title() {
      let { plates } = this.$store.state;
      if (this.plateId == "search") {
        return "搜索结果"
      }
      let arrs = plates.filter(item => item.uuid == this.plateId)
      if(arrs[0]&&arrs[0].CategoryChildren&&arrs[0].CategoryChildren.length>0&&this.childId)
      {
        let childarrs = arrs[0].CategoryChildren.filter(item => item.uuid == this.childId);
        this.childName = childarrs[0].name;
      }

      this.CategoryChildren =  arrs[0].CategoryChildren;
      return arrs.length === 0 ? "未配置" : arrs[0].name
    }
  },
  created() {
    if (this.plateId == "search") {
      this.getSearch();
    } else {
      let { plates } = this.$store.state;
      let arrs = plates.filter(item => item.uuid == this.plateId)
      if(arrs[0]&&arrs[0].CategoryChildren&&arrs[0].CategoryChildren.length>0&&!this.childId)
      {
        this.childId = arrs[0].CategoryChildren[0].uuid
      }

      this.getNewsViews();
      this.getPicNews();
    }
  },
  mounted() {
    this.toTop();
  },
  methods: {
    async getSearch() {
      let result = await getSearch(this.$route.query.keyWords);
      result = result.data;
      this.totalNum = result.count;
      this.realList = result || [];
    },
    async changeArticleList(childId,name){
      this.childName = name;
      this.childId = childId;
        this.getNewsViews()
        this.getPicNews()
    },
    async getNewsViews() {
      let result = await getNewsViews(this.plateId, this.current,10,this.childId);
      this.totalNum = result.count;
      result = result.data;
      console.log("this.totalNum =",this.totalNum)
      this.realList = result || [];
    },
    async getPicNews(){
      let result = await getPlatePicNews(this.plateId,this.childId);
      result = result.data;
      this.arrPicNews = result || [];
    },
    async toPage(val) {
      this.current = val;
      let result = await getNewsViews(this.plateId, val,10,this.childId);
      result = result.data;
      this.realList = result || [];
    },
    toTop() {
      document.body.scrollTop = 0;
      document.documentElement.scrollTop = 0;
    }
  }
};
</script>
<style scoped>
.box{
  position: relative;
  width: 100%;
  margin: 0 auto;
  /* background-color: #fff; */
}
.newsviews{
  position: relative;
  width: 1300px;
  min-height: 964px;
  margin: 0 auto;
  overflow: hidden;
}
.newsviews>.pages{
  position: relative;
  margin-top:9px;
  width: 1300px;
  height: 36px;
  display: flex;
  justify-content: end;
}
.newsviews>.pages>li{
  margin-right: 23px;
  width: 34px;
  height: 34px;
  border: 1px solid #EDEDED;
  font-size: 14px;

  font-weight: 500;
  color: #999999;
  line-height: 34px;
  text-align: center;
}
.newsviews>.pages>li.up{
  background:url(/static/img/left.png) ;
  background-size: 34px 34px;
}
.newsviews>.pages>li.show{
  background: #306BCD;
  color: #FFFFFF;
}
.newsviews>.pages>li.next {
  background: url(/static/img/right.png);
  background-size: 34px 34px;
}
.newsviews .tab{
  margin: 0px 0 16px 0;
  width: 300px;
  height: 14px;
  font-weight: 500;
  font-size: 14px;
  font-weight: 400;
  color: #D9D9D9;
  line-height: 16px;
}
.newsviews .tab a{
  color: #D9D9D9;
}
.newsviews .views{
  min-height: 796px;
  padding: 40px;
  padding-right: 18px;
  background-color: #fff;
  display: flex;
}
/* .newsviews .views .rightitem ul li{
  display: flex;
  justify-content: start;
} */
.newsviews .views .rightitem ul li{

  width: 100%;
  height: 51px;
  /* background-color: #fcfcfc; */

}
.newsviews .views .rightitem ul li:nth-child(5){
  margin-bottom: 30px;
}
.newsviews .views .rightitem ul li h4{
  font-size: 18px;
  height: 51px;
  line-height: 51px;
  width: 875px;
  display: inline-block;
  /* font-weight: bold; */
  color: #000000;
  overflow: hidden;
}
.newsviews .views .rightitem ul li .addtime{
  position: relative;
  display: inline-block;
  height: 51px;
  line-height: 51px;
  padding-left:0px;
  padding-right: 29px;
  float: right;
  font-size: 18px;
font-family: PingFang SC;
font-weight: 500;
color: #666666;
}
.leftitem {
width: 183px;
display: inline-block;
}
.leftitem ul li{
  width: 127px !important;
  
  height: 72px;
  /* background: #F7FAFF; */
  /* border: 1px solid #0041BE; */
  background: #F8F8F8;
  border-radius: 20px 0px 20px 0px;
  text-align: center;
  padding: 23px 0;
  margin-bottom: 11px;
}
.leftitem ul li p{
  margin-top:15px;
  font-size: 18px;
font-family: PingFang SC;
font-weight: 500;
color: #000000;
}
.rightitem{
  width: 1035px;
    display: inline-block;
    /* position: absolute; */
}
.rightitem .title{
  width: 1035px;
  height: 53px;
  border-bottom: solid 1px #E1EEFC;
  margin-bottom: 25px;
}
.rightitem .title::after{
  content: "";
    background-image: url(/static/img/title-icon.png);
    background-repeat: no-repeat;
    position: relative;
    width: 20px;
    height: 20px;
    display: block;
    top: -9px;
    left: 38px;
}
.rightitem h1{
  font-size: 22px;
  font-family: PingFang SC;
  font-weight: bold;
  color: #004FB7;
  border-bottom: solid 3px #004FB7;
  width: 90px;
  height: 53px;
    line-height: 53px;
}
.leftIcon{
  font-size:43px;
  
}
.el-pagination{
  float: right;
    margin-top: 21px;
    margin-right: 26px;
}
.leftitem ul .activeli{
    background: #F7FAFF; 
   border: 1px solid #0041BE;
   color: #004FB7;
}
.swiperLeft{
  width: 756px;
  height: 392px;
  display: inline-block;
}
.swiperRight{
  width: 230px;
  height: 322px;
  background-image: url(/static/img/bgNewView.png);
  padding: 45px 23px 26px 22px;
}
.swiperRight h2{
  font-size: 18px;
/* font-family: PingFang SC; */
font-weight: bold;
color: #FEFEFF;
line-height: 30px;
    height: 61px;
    overflow: hidden;
      word-break: break-all;
    overflow: hidden;
-webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
}
.swiperRight p{
  font-size: 16px;
  /* font-family: PingFang SC; */
  font-weight: 500;
  color: #FEFEFF;
  line-height: 23px;
  height: 95px;
  width: 230px;
  overflow: hidden;
      word-break: break-all;
    overflow: hidden;
-webkit-line-clamp: 4;
    -webkit-box-orient: vertical;
  margin-top:48px;
}
.swiperRight .pageIndex{
  text-align: center;
  font-size: 18px;
  margin-top:90px;
}
.el-carousel__item{
  display: flex;
  
}

</style>
